import { instance } from '@/services/avik-api-gateway'
import { DailyReportEvent } from '@/types/daily-report-event'
import { AxiosResponse } from 'axios'

export function createDailyReportEvent(
  body: Partial<DailyReportEvent>
): Promise<AxiosResponse<DailyReportEvent>> {
  return instance.post(`/daily-report/event`, body)
}
